import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';
import ReportsAPI from './../../../../Reports/api/reports_api';
import NumberToLetters from './../../../../../utils/NumberToletters';
import { calculateAgeParse } from '../../../../Utils/Patient';
import { formatNumber } from '../../../../Utils/Money';

const generateDocDefTemplate2 = async (obj) => {
    console.log("DATAINVOICEPDF", obj);

    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };

    const city = sessionStorage.getItem('id_ciudad');
    const dept = parseInt(sessionStorage.getItem('id_dpto'));
    const getCity = await ReportsAPI.loadCity(city);
    const getDepts = await ReportsAPI.loadDepartment();
    const deptoProfile = getDepts.find((depto) => depto.id === dept)
    console.log(deptoProfile)
    let invoiceNote = !!obj.nota ? obj.nota : "";

    let cityReport = getCity.length > 0 ? getCity[0].ciunom : ' ';
    let deptoReport = deptoProfile !== null ? deptoProfile.depnom : '';

    let cantItems = 0;
    for (var i = 0; i < obj.items.length; i++) {
        cantItems = cantItems + 1;
    }

    let negType = obj.recibosCaja[0].tipo_negociacion_contrato == 1 ? 'Credito' : obj.recibosCaja[0].tipo_negociacion_contrato == 2 ? 'Contado' : obj.recibosCaja[0].tipo_negociacion_contrato == 3 ? 'Otros' : '';
    let wayPaymentContract = '';
    if (obj.recibosCaja[0].medio_pago_contrato !== null && obj.recibosCaja[0].medio_pago_contrato === 1) {
        wayPaymentContract = 'Acuerdo Mutuo';
    } else if (obj.recibosCaja[0].medio_pago_contrato !== null && obj.recibosCaja[0].medio_pago_contrato === 2) {
        wayPaymentContract = 'Efectivo';
    } else if (obj.recibosCaja[0].medio_pago_contrato !== null && obj.recibosCaja[0].medio_pago_contrato === 3) {
        wayPaymentContract = 'Transferencia';
    } else {
        wayPaymentContract = '';
    }

    let tipo_contribuyente = obj.profile.tipo_contribuyente !== null && obj.profile.tipo_contribuyente !== undefined ? obj.profile.tipo_contribuyente : 0;
    let name_contribuyente;
    switch (parseInt(tipo_contribuyente)) {
        case 1:
            name_contribuyente = 'PERSONA NATURAL'
            break;
        case 2:
            name_contribuyente = 'PERSONA JURIDICA'
            break;
        default:
            name_contribuyente = '';
            break;
    }

    let emision = new Date(obj.fecha_emision);
    let expirationDate = obj.recibosCaja[0].diasvencimiento != null && obj.recibosCaja[0].diasvencimiento != undefined ? parseInt(obj.recibosCaja[0].diasvencimiento) : 30;
    //let expirationDateinvoice = new Date();
    let expirationDateinvoice = moment(emision).add(expirationDate, 'days').format("DD-MM-YYYY");

    //Tabla de Informacion Juridica
    let tipDoc = obj.esFactura == true ? "Factura Electrónica de Venta" : "Cuenta de Cobro";
    let itemBodyInformation = [];

    itemBodyInformation.push(
        [{ text: 'Cliente: ' +obj.tercero.nombre, style: 'textInfoInvoice' }, { text: tipDoc, style: 'textInfoInvoice' }],
        [{ text: 'Contrato: ' +'No. ', style: 'textInfoInvoice', alignment: "left" }, { text: 'Moneda: ' + 'COP Colombia,pesos', alignment: "left" }],
        [{ text: 'NIT: ' +obj.tercero.nit, style: 'textInfoInvoice', alignment: "left" }, { text: 'No: ' + obj.num_fac_ter, alignment: "left", bold: true }],
        [{ text: 'Direccion: ' +obj.tercero.direccion.direccion, style: 'textInfoInvoice', alignment: "left" }, { text: 'Fecha Emision: ' + moment(obj.fecha_emision).format("DD-MM-YYYY"), alignment: "left" }],
        [{ text: 'Telefono: ' +obj.tercero.telefono, style: 'textInfoInvoice', alignment: "left" }, ''],
        [{ text: 'Email: ' +obj.tercero.correo, style: 'textInfoInvoice', alignment: "left" }, { text: 'Total de lineas o items: ' + cantItems, alignment: "left" }],
        [{ text: 'Tipo de Negociación: ' +negType, style: 'textInfoInvoice', alignment: "left" }, ''],
        [{ text: 'Medio de Pago: ' +wayPaymentContract, style: 'textInfoInvoice', alignment: "left" }, ''],
        [{ text: 'Fecha de Vencimiento: ' +expirationDateinvoice, style: 'textInfoInvoice', alignment: "left" }, '']
    );

    let casilla1 =
        "Cliente: " + obj.tercero.nombre + "\n" +
        "Contrato: " + "No." + "\n" +
        "NIT: " + obj.tercero.nit + "\n" +
        "Direccion: " + obj.tercero.direccion.direccion + "\n" +
        "Telefono: " + obj.tercero.telefono + "\n" +
        "Email: " + obj.tercero.correo + "\n\n" +
        "Tipo de Negociación: " + negType + "\n" +
        "Medio de Pago: " + wayPaymentContract + "\n" +
        "Fecha de Vencimiento: " + expirationDateinvoice;
    let casilla2 =
        tipDoc + "\n" +
        "Moneda: COP Colombia,pesos \n" +
        "No: " + obj.num_fac_ter + "\n" +
        "Fecha Emision: " + moment(obj.fecha_emision).format("DD-MM-YYYY") + "\n\n" +
        "Total de lineas o items: " + cantItems + "\n";

   /*  itemBodyInformation.push([
        { text: casilla1, alignment: "left" },
        { text: casilla2, alignment: "left" },
    ]); */

    //Tabla de Contenido
    let itemBody = [
        [
            {
                text: "#",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Codigo",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Descripcion",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "U.M",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Cantidad",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Precio U",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "IVA",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Dcto",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Total",
                style: "tableHeader",
                alignment: "center",
            },
        ],
    ];
    let itemArr = ["", "", "", "", "", "", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
        const element = obj.items[index];
        itemBody.push([
            { text: index + 1, alignment: "right" },
            { text: element.cupscod !== null ? element.cupscod : element.referencia, alignment: "center" },
            { text: element.descripcion, alignment: "center" },
            { text: element.um, alignment: "center" },
            { text: element.cantidad, alignment: "center" },
            { text: formatNumber(element.precio), alignment: "center" },
            { text: "0.00", alignment: "center" },
            { text: "0", alignment: "center" },
            { text: formatNumber(element.costo_total), alignment: "center" },
        ]);
    }

    const conceptPayment = () => {
        let receipts = obj.recibosCaja;
        let conPayment = 0;
        for (let i = 0; i < receipts.length; i++) {
            const element = receipts[i];
            conPayment += parseInt(element.total);
        }
        return conPayment;
    }

    let totalFactura = parseInt(obj.total) - parseInt(conceptPayment());

    //Tabla de Informacion Juridica
    let itemBodyObservation = [];
    let casilla1tot = "Observaciones: " + invoiceNote;
    itemBodyObservation.push([
        { text: casilla1tot, alignment: "left" }
    ]);

    //Tabla de Informacion Juridica
    let itemBodyTotals = [];
    itemBodyTotals.push(
        [
            { text: 'Subtotal', alignment: "left", bold: true },
            { text: '$' + formatNumber(obj.total.toString()), alignment: "left" }
        ],
        [
            { text: 'Cargos', alignment: "left", bold: true },
            { text: '$0.0', alignment: "left" }
        ],
        [
            { text: 'Descuentos', alignment: "left", bold: true },
            { text: '$0.0', alignment: "left" }
        ],
        [
            { text: 'Abonos CM | CR | COPAGOS', alignment: "left", bold: true },
            { text: '$' + formatNumber(conceptPayment()), alignment: "left" }
        ],
        [
            { text: 'Iva', alignment: "left", bold: true },
            { text: '$0.0', alignment: "left" }
        ],
        [
            { text: 'Total de la Operacion', alignment: "left", bold: true },
            { text: '$' + formatNumber(totalFactura), alignment: "left" }
        ]
    );


    let tableBodyPatients = [];

    tableBodyPatients.push(
        [{ text: '\nExtensión Pacientes ', style: 'tableheader', alignment: 'center', bold: true }],
    );
    try {
        for (let k = 0; k < obj.recibosCaja.length; k++) {

            let gender;
            switch (obj.recibosCaja[k].paciente_genero) {
                case "F":
                    gender = 'FEMENINO'
                    break;
                case "M":
                    gender = 'MASCULINO'
                    break;

                default:
                    break;
            }
            let userType;
            switch (obj.recibosCaja[k].tipo_usuario_salud) {
                case '01':
                    userType = 'AFILIADO AL RÉGIMEN SUBSIDIADO';
                    break;
                case '02':
                    userType = 'COTIZANTE';
                    break;
                case '03':
                    userType = 'BENEFICIARIO';
                    break;
                case '04':
                    userType = 'ADICIONAL';
                    break;
                case '05':
                    userType = 'RÉGIMEN ESPECIALES O DE EXCEPCIÓN';
                    break;
                case '06':
                    userType = 'TOMADOR/AMPARADO';
                    break;
                case '07':
                    userType = 'SIN RÉGIMEN';
                    break;

                default:
                    userType = '';
                    break;
            }

            let negType = obj.recibosCaja[k].tipo_negociacion_contrato == 1 ? 'Credito' : obj.recibosCaja[k].tipo_negociacion_contrato == 2 ? 'Contado' : obj.recibosCaja[k].tipo_negociacion_contrato == 3 ? 'Otros' : '';

            tableBodyPatients.push(
                {
                    unbreakable: true,
                    margin: [10, 10, 10, 10],
                    layout: 'lightHorizontalLines',
                    table: {
                        widths: ['auto', '*', 'auto', '*'],
                        body: [
                            [{ text: 'Tipo de Identificación ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].tip_documento_paciente, style: 'textStyle' },
                            { text: 'Numero Identificacion ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].num_documento_paciente, style: 'textStyle' }],
                            [{ text: 'Primer apellido ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].apellido1, style: 'textStyle' },
                            { text: 'Segundo Apellido ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].apellido2, style: 'textStyle' }],
                            [{ text: 'Primer Nombre ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].primer_nombre_paciente, style: 'textStyle' },
                            { text: 'Segundo Nombre ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].segundo_nombre_paciente !== null && obj.recibosCaja[k].segundo_nombre_paciente !== undefined ? obj.recibosCaja[k].segundo_nombre_paciente : '', style: 'textStyle' }],
                            [{ text: 'Genero ', style: 'textStyle', bold: true },
                            { text: gender, style: 'textStyle' },
                            { text: 'Tipo Sangre Paciente ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].tipo_sangre_paciente, style: 'textStyle' }],
                            [{ text: 'Fecha de Nacimiento ', style: 'textStyle', bold: true },
                            { text: moment(obj.recibosCaja[k].fec_nacimiento_paciente).format('DD-MM-YYYY'), style: 'textStyle' },
                            { text: 'Edad ', style: 'textStyle', bold: true },
                            { text: calculateAgeParse(obj.recibosCaja[k].fec_nacimiento_paciente), style: 'textStyle' }],
                            [{ text: 'Dirección ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].direccion_paciente.direccion, style: 'textStyle' },
                            { text: 'Ciudad ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].direccion_paciente.id_ciudad + ' ' + obj.recibosCaja[k].direccion_paciente.ciudad, style: 'textStyle' }],
                            [{ text: 'Teléfono ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].celular_paciente, style: 'textStyle' },
                            { text: 'Admision ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].id_admision, style: 'textStyle' }],
                            [{ text: 'Número Autorización ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].codigo_autorizacion, style: 'textStyle' },
                            { text: 'Tipo Usuario ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].tipo_usuario_salud !== null && obj.recibosCaja[k].tipo_usuario_salud !== undefined ? obj.recibosCaja[k].tipo_usuario_salud + ' - ' + userType : '', style: 'textStyle' }],
                            [{ text: 'Número contrato ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].numero_contrato, style: 'textStyle' },
                            { text: 'Recibo caja ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].num_recibo, style: 'textStyle' }],
                            [{ text: 'Fecha de Admisión ', style: 'textStyle', bold: true },
                            { text: moment(obj.recibosCaja[k].fecha_admision).format('DD-MM-YYYY'), style: 'textStyle' },
                            { text: 'Tipo de Negociación ', style: 'textStyle', bold: true },
                            { text: obj.recibosCaja[k].tipo_negociacion_contrato + ' ' + negType, style: 'textStyle' }],
                            [{ text: 'Abonos CM | CR | COPAGO ', style: 'textStyle', bold: true },
                            { text: '$' + formatNumber(obj.recibosCaja[k].total), style: 'textStyle' }, '', ''],
                        ],
                    },
                });
        }
    }
    catch (e) {
        console.log(e);
    }


    pdfMake.tableLayouts = {
        exampleLayout: {
            hLineWidth: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return 1;
                }
                return i === node.table.headerRows ? 2 : 1;
            },
            vLineWidth: function (i) {
                return 1;
            },
            hLineColor: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return "black";
                }
                return i === 1 ? "black" : "#aaa";
            },
            fillColor: function (i, node) {
                return i === 0 ? "white" : i % 2 === 0 ? "#e8e8e8" : null;
            },
            paddingLeft: function (i) {
                return i === 0 ? 8 : 8;
            },
            paddingRight: function (i, node) {
                //return i === node.table.widths.length - 1 ? 0 : 8;
                return 3;
            },
            paddingTop: function (i, node) {
                return 3;
            },
            paddingBottom: function (i, node) {
                return 3;
            },

        },
    };

    const validateFooterAutorization = (obj) => {
        if (obj.esFactura == true) {
            let foot = {
                text: obj.autorizacion_text,
                fontSize: 9,
                alignment: "center"
            }
            return foot;
        }
        else {
            return null;
        }
    }

    const header = {
        margin: [0, 0, -30, 0],
        layout: 'noBorders',
        table: {
            widths: ['*', 'auto', '*'],
            body: [
                [{
                    image: await getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + obj.profile.id_clinica + "/logo/" + sessionStorage.getItem('token')),
                    fit: [180, 90],
                    alignment: 'center'
                },
                {
                    layout: 'noBorders',
                    table: {
                        body: [
                            [{ text: obj.profile.nombre, style: 'head', alignment: 'center' }],
                            [{ text: 'NIT: : ' + obj.profile.nit, style: 'texthead', alignment: 'center' }],
                            [{ text: name_contribuyente, style: 'texthead', alignment: 'center' }],
                            [{ text: obj.profile.direccion.direccion, style: 'texthead', alignment: 'center' }],
                            [{ text: obj.profile.telefono1, style: 'texthead', alignment: 'center' }],
                            [{ text: obj.profile.email, style: 'texthead', alignment: 'center' }],
                            [{ text: cityReport + ', ' + deptoReport, style: 'texthead', alignment: 'center' }],
                        ],
                        alignment: 'center',
                    },
                },
                {
                    width: "*",
                    columns: [
                        await propsQRCode(obj.urlDian)
                    ],
                    alignment: 'center'
                },],
            ],
        },
    };

    var docDefinition = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        pageMargins: [26, 25, 26, 20],
        info: {
            title: "Factura No#" + obj.num_fac_ter,
            author: "",
        },
        /*footer: function (currentPage, pageCount, pageSize) {
            return [
                {
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 0,
                            w: pageSize.width,
                            h: 5,
                        },

                    ],
                }
            ];
        },*/
        /*
        header: function (currentPage, pageCount, pageSize) {
            return [
                {
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 10,
                            w: pageSize.width,
                            h: 3,
                        },
                    ],
                },
            ];
        },
        */
        content: [
            header,
            {
                text: obj.cufe != null ? "\n\n\n CUFE/CUDE:" + obj.cufe : "\n\n\n",
                fontSize: 9,
            },
            {
                style: "tableExample",
                table: {
                    headerRows: 1,
                    widths: ['*', '*'],
                    heights: 0,
                    body: itemBodyInformation,
                },
                /* layout: "exampleLayout", */
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 0;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 0;
                    },
                },
                dontBreakRows: true,
            },
            /*  {
                 columns: [
                     {
                         style: "tableTop",
                         table: {
                             headerRows: 1,
                             widths: [80, '*'],
                             heights: function (row) {
                                 return (row);
                             },
                             body: itemBodyInformation2,
                         },
                         layout: "exampleLayout",
                         layout: {
                             hLineWidth: function (i, node) {
                                 return (i === 0 || i === node.table.body.length) ? 1 : 0;
                             },
                             vLineWidth: function (i, node) {
                                 return (i === 0 || i === node.table.widths.length) ? 1 : 0;
                             },
                             canvas: [
                                 {
                                     type: 'rect',
                                     x: 0,
                                     y: 0,
                                     w: 285,
                                     h: 130,
                                     r: 5,
                                     lineColor: 'black',
                                 },
                             ],
                         },
                         dontBreakRows: true,
                     },
                 ]
             }, */
            {
                style: "tableExample",
                table: {
                    headerRows: 1,
                    widths: [5, 30, 225, 30, 20, 50, 20, 20, 50],
                    //keepWithHeaderRows: 1,
                    body: itemBody,
                },
                layout: "exampleLayout",
                dontBreakRows: true,
            },
            {
                margin: [0, 0, 0, 2],
                columns: [
                    {
                        style: "tableExample2",
                        table: {
                            headerRows: 1,
                            widths: [275],
                            heights: [100],
                            //keepWithHeaderRows: 1,
                            body: itemBodyObservation,
                        },
                        layout: "exampleLayout",
                        dontBreakRows: true,
                    },
                    {
                        style: "tableExample3",
                        table: {
                            headerRows: 1,
                            widths: [120, 120],
                            //keepWithHeaderRows: 1,
                            body: itemBodyTotals,
                        },
                        layout: "exampleLayout",
                        dontBreakRows: true,
                        relativePosition: { x: -10 }
                    }
                ]
            },
            {
                text: "\nSon: " + NumberToLetters(obj.neto.toString(), {
                    plural: 'PESOS',
                    singular: 'PESO',
                }) + "\n",
                fontSize: 9,
            },
            validateFooterAutorization(obj),
            obj.recibosCaja.length > 0 && obj.recibosCaja !== null && obj.recibosCaja !== undefined ?
                tableBodyPatients
                : null,


        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            head: {
                fontSize: 14,
                margin: [0, 0, 0, 0],
            },
            texthead: {
                fontSize: 10,
                margin: [0, 0, 0, 0],
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5],
            },
            tableExample: {
                margin: [0, 3, 0, 3],
                fontSize: 9
            },
            tableExample2: {
                margin: [0, 3, 0, 3],
                fontSize: 9
            },
            tableExample3: {
                margin: [0, 3, 0, 3],
                fontSize: 9,
            },
            tableHeader: {
                bold: true,
                fontSize: 9,
                color: "black",
            },
            textStyle: {
                fontSize: 9,
                alignment: "left"
            },
            textInfoInvoice: {
                fontSize: 8,
                lineHeight: 1
            }
        },
        defaultStyle: {
            columnGap: 15,
        },
    };

    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });
};

const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

const propsQRCode = async (urlDian) => {
    if (urlDian != null) {
        return {
            image: await getBase64ImageFromURL("https://api.qrserver.com/v1/create-qr-code/?data=" + urlDian),
            width: 100,
            height: 100,
        }
    }
    else {
        return {}
    }
}
export default generateDocDefTemplate2;